import { render, staticRenderFns } from "./AlertComponentBottom.vue?vue&type=template&id=b1ce3fde&scoped=true&"
import script from "./AlertComponentBottom.vue?vue&type=script&lang=ts&"
export * from "./AlertComponentBottom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ce3fde",
  null
  
)

export default component.exports